<template>
  <div class="ai-improve-panel">
    <AIImprovePanelComingSoonLayout v-if="isComingSoonLayoutVisible" />
    <div v-if="!canEditPresentation" class="overlay-disable-edit"></div>
    <AIAutoImproveWriting class="ai-improve-panel__content" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

// components
import AIAutoImproveWriting from '@/components-v2/presentation-editor/side-right/right-nav/AIAutoImproveWriting.vue'
import AIImprovePanelComingSoonLayout from '@/components-v2/presentation-editor/side-right/right-nav/AIImprovePanelComingSoonLayout.vue'

export default {
  title: 'Improve Writing',
  name: 'AIImprovePanel',

  components: {
    AIAutoImproveWriting,
    AIImprovePanelComingSoonLayout,
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      canEditPresentation: (state) => state.canEditPresentation,
    }),

    ...mapGetters('slideType', ['isExcludedSlideTypesForImprovingSlideContent']),

    isComingSoonLayoutVisible() {
      return this.isExcludedSlideTypesForImprovingSlideContent
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/variable.scss";

.ai-improve-panel {
  @apply relative h-full;
}
.ai-improve-panel__content {
  @apply overflow-y-auto px-4 pt-0 relative;
  margin-top: calc($right-panel-header-height + 1.5rem);
  padding-bottom: $right-panel-header-height;
  height: calc(100% - $right-panel-header-height);
}
.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full;
  z-index: 9;
}
</style>
